<template>

  <div>

    <div class="subBtn" @click="faPost">

      <Icon type="ios-create-outline" size="30" />

      发帖子

    </div>

    <div class="subCenter">

      <div class="subCenterItem" @click="toMyQuestion">

        <Badge :count="questionCount">

          <div>

            <Icon type="ios-chatboxes-outline" size="30" color="#007BFF" />

          </div>

        </Badge>

        <span>问答</span>

      </div>



      <div class="subCenterItem" @click="toFollowQuestion">

        <div class="last"><Icon type="md-heart-outline" size="30" color="#FFA000" /></div>

        <span>我关注的问题</span>

      </div>



      <!-- <div class="subCenterItem" @click="toPostDetail()">

        <div class="last1"><Icon type="ios-card" size="30" color="#4BB9A9" /></div>

        <span>学习卡常见问题</span>

      </div> -->

      <!-- <div class="subCenterItem" @click="toDownloadTools">

        <div class="last2"><Icon type="ios-construct-outline" size="30" color="#F44336" /></div>

        <span>学习卡修复工具下载</span>

      </div> -->

    </div>

    <Modal v-model="showModal" title="写帖子" width="900" :mask-closable="false">

      <Form ref="formData" :model="formData" :label-width="70" :rules="formDataValidate">

        <FormItem label="封面：" prop="questionCover">

          <UploadCon

            uploadKey="questionCover"

            ref="questionCover"

            :multipleLength="1"

            :defaultData="defaultPhoto"

            :actionUrl="urlData.url"

            :headersUrl="urlData.headers"

            :formatData="['jpg', 'jpeg', 'png']"

            :maxSize="20480"

            :uploadStyleWH="['100%', '100%']"

            :uploadImgStyleWH="['190px', '120px']"

            :showUploadList="false"

            type="drag"

            @handleSuccess="handleSuccess"

            @handleRemImgList="handleRemImgList"

          >

            <div style="width: 190px;height:120px;line-height: 120px;">

              <Icon type="ios-camera" size="25" />

            </div>

          </UploadCon>

        </FormItem>

        <FormItem label="标题：" prop="questionTitle">

          <Input v-model="formData.questionTitle" autocomplete="off" placeholder="请输入标题" :maxlength="200" @on-change="titleChange" />

        </FormItem>

        <FormItem label="摘要：" prop="questionAbstract">

          <Input v-model="formData.questionAbstract" autocomplete="off" placeholder="请输入摘要" />

        </FormItem>

        <FormItem label="内容：" prop="questionBody">

          <Editor style="width: 260px;" v-model="formData.questionBody" :isUploadFile="false" v-if="showModal" />

        </FormItem>

      </Form>



      <div slot="footer">

        <Button type="text" @click="handleOnClick('modalNo')">取消</Button>

        <Button type="primary" :loading="submitLoading" @click="handleOnClick('modalOkSubmit')">发布</Button>

      </div>

    </Modal>

  </div>

</template>

<script>

import { postRequest } from '@/libs/axios'

import UploadCon from '@/views/my-components/upload-con/uploadCon.vue'

import util from '@/libs/util.js'

import Editor from '@/views/my-components/editor.vue'

export default {

  components: {

    UploadCon,

    Editor

  },

  props: {

    columnId: {

      type: String || Number,

      default: '-1'

    },

    questionCount: {

      type: Number,

      default: 0

    }

  },

  data() {

    return {

      defaultPhoto: [],

      urlData: util.uploadFileUrlParams('/v3/upload/uploadPublicFile', false),

      showModal: false,

      submitLoading: false,

      formData: {

        columnId: ''

      },

      formDataValidate: {

        questionTitle: [

          {

            required: true,

            message: '名称不能为空',

            trigger: 'blur'

          }

        ],

        questionAbstract: [

          {

            required: true,

            message: '摘要不能为空',

            trigger: 'blur'

          }

        ],

        questionBody: [

          {

            required: true,

            message: '内容不能为空',

            trigger: 'blur'

          }

        ]

      },

      isActive: true,

      userInfo: {}

    }

  },

  mounted() {},

  methods: {

    titleChange() {

      if (this.formData.questionTitle.length >= 200) {

        this.$Message.warning('标题不得大于200字')

      }

    },

    faPost() {

      this.formData = {}

      this.showModal = true

    },

    async handleOnClick(type, row) {

      switch (type) {

        case 'modalOkSubmit':

          this.$refs.formData.validate(async valid => {

            if (valid) {

              this.submitLoading = true

              delete this.formData.id

              this.formData.columnId = this.columnId

              const result = await postRequest('/v3/Community/teacher/issueQuestion', this.formData, false)

              if (result.success) {

                this.$Message.success('发布成功')

                this.defaultPhoto = []

                this.showModal = false

                // this._getQuestion(this.columnId)

                this.$emit('getQuestion', this.columnId)

              }

              this.submitLoading = false

            }

          })

          break

        case 'modalNo':

          this.handleModalReset()

          break

      }

    },

    // 关闭弹框清楚所有值

    handleModalReset() {

      this.showModal = false

      this.$refs.formData.resetFields()

      this.defaultPhoto = []

    },

    toMyQuestion() {

      this.$router.push({

        name: 'questionOfMine'

      })

    },

    toPostDetail() {

      this.$router.push({

        name: 'questionDetail',

        query: { id: '381561627859750914' }

      })

    },
    toDownloadTools(){
      window.location.href="https://xiongbangzhu.oss-cn-beijing.aliyuncs.com/0/publicFile/9c15c11b8aff4859bb6c56c0e1ec485c.pdf";
    },
    // 图片上传成功回调

    handleSuccess(res) {

      this.formData.questionCover = res.result

      this.defaultPhoto.push({

        url: res.result,

        name: 'questionCover'

      })

    },

    // 图片删除回调

    handleRemImgList(res) {

      this.formData.questionCover = ''

      this.defaultPhoto = []

    },

    toFollowQuestion() {

      this.$router.push({

        name: 'followQuestion'

      })

    }

  }

}

</script>

<style lang="less" scoped>

.subBtn {

  width: 100%;

  height: 0.86rem;

  line-height: 0.86rem;

  text-align: center;

  border-radius: 0.06rem;

  color: #fff;

  font-size: 0.22rem;

  background: linear-gradient(180deg, #ffa000 0%, #ffc107 100%);

  cursor: pointer;

}

.subCenter {

  width: 3.75rem;

  justify-content: space-between;

  margin-top: 0.1rem;

  .subCenterItem {

    width: 1.82rem;

    height: 1.12rem;

    border-radius: 0.06rem;

    background-color: #fff;

    display: inline-flex;

    flex-direction: column;

    align-items: center;

    justify-content: center;

    cursor: pointer;

    margin-bottom: 0.1rem;

    div {

      display: inline-flex;

      justify-content: center;

      align-items: center;

      width: 0.48rem;

      height: 0.48rem;

      border-radius: 50%;

      background-color: #cce4ff;

      margin-bottom: 0.1rem;

    }

    .last {

      background-color: #fff3cd;

    }

    .last1 {

      background-color: #dbf1ee;

    }

    .last2 {

      background-color: #fdd9d7;

    }

  }

}

</style>




// WEBPACK FOOTER //
// src/views/teacher/components/faPost.vue